import { FluidsConstants } from './fluids.constants'
import { IFluidsAction, IFluidsState } from './fluids.types'

export const initialFluidsState: IFluidsState = {
  transportType: 'before',
  beforeIntakeCrys: '',
  beforeIntakeColl: '',
  beforeIntakeOther: '',
  beforeIntakeFeedings: '',
  beforeOutputEbl: '',
  beforeOutputUo: '',
  beforeOutputOther: '',
  beforeOutputBm: null,
  duringIntakeCrys: '',
  duringIntakeColl: '',
  duringIntakeOther: '',
  duringIntakeFeedings: '',
  duringOutputEbl: '',
  duringOutputUo: '',
  duringOutputOther: '',
  duringOutputBm: null,
  isNeonatal: false,
  customFluids: [],
}

export function fluidsReducer(state: IFluidsState = initialFluidsState, action: IFluidsAction): IFluidsState {
  switch (action.type) {
    case FluidsConstants.SET_TRANSPORT_TYPE:
      return { ...state, transportType: action.transportType || 'before' }
    case FluidsConstants.SET_BEFORE_INTAKE_CRYS:
      return { ...state, beforeIntakeCrys: action.beforeIntakeCrys }
    case FluidsConstants.SET_BEFORE_INTAKE_COLL:
      return { ...state, beforeIntakeColl: action.beforeIntakeColl }
    case FluidsConstants.SET_BEFORE_INTAKE_OTHER:
      return { ...state, beforeIntakeOther: action.beforeIntakeOther }
    case FluidsConstants.SET_BEFORE_INTAKE_FEEDINGS:
      return { ...state, beforeIntakeFeedings: action.beforeIntakeFeedings }
    case FluidsConstants.SET_BEFORE_OUTPUT_EBL:
      return { ...state, beforeOutputEbl: action.beforeOutputEbl }
    case FluidsConstants.SET_BEFORE_OUTPUT_UO:
      return { ...state, beforeOutputUo: action.beforeOutputUo }
    case FluidsConstants.SET_BEFORE_OUTPUT_OTHER:
      return { ...state, beforeOutputOther: action.beforeOutputOther }
    case FluidsConstants.SET_BEFORE_OUTPUT_BM:
      return { ...state, beforeOutputBm: action.beforeOutputBm }
    case FluidsConstants.SET_DURING_INTAKE_CRYS:
      return { ...state, duringIntakeCrys: action.duringIntakeCrys }
    case FluidsConstants.SET_DURING_INTAKE_COLL:
      return { ...state, duringIntakeColl: action.duringIntakeColl }
    case FluidsConstants.SET_DURING_INTAKE_OTHER:
      return { ...state, duringIntakeOther: action.duringIntakeOther }
    case FluidsConstants.SET_DURING_INTAKE_FEEDINGS:
      return { ...state, duringIntakeFeedings: action.duringIntakeFeedings }
    case FluidsConstants.SET_DURING_OUTPUT_EBL:
      return { ...state, duringOutputEbl: action.duringOutputEbl }
    case FluidsConstants.SET_DURING_OUTPUT_UO:
      return { ...state, duringOutputUo: action.duringOutputUo }
    case FluidsConstants.SET_DURING_OUTPUT_OTHER:
      return { ...state, duringOutputOther: action.duringOutputOther }
    case FluidsConstants.SET_DURING_OUTPUT_BM:
      return { ...state, duringOutputBm: action.duringOutputBm }
    case FluidsConstants.SET_IS_NEONATAL:
      return { ...state, isNeonatal: action.isNeonatal }
    case FluidsConstants.SET_FLUIDS_STATE:
      return { ...state, ...action.fluids }
    case FluidsConstants.SET_CUSTOM_FLUID_VALUE:
      return {
        ...state,
        currentCustomFluidValue: action.value,
        currentCustomFluidOptionId: action.optionId,
        currentCustomFluidTransportPeriod: action.transportPeriod,
      }
    case FluidsConstants.SET_CUSTOM_FLUIDS:
      return { ...state, customFluids: action.customFluids || [] }
    case FluidsConstants.RESET_FLUIDS_STATE:
      return { ...initialFluidsState }
    case FluidsConstants.CLEAR_FLUIDS_FIELDS:
      return { ...initialFluidsState, isNeonatal: state.isNeonatal }
    default:
      return state
  }
}
